import {Observable} from 'rxjs/Observable';

// TODO
// creare un'interfaccia di riferimento

export class AttachedFile {
	uuid: string;
	file_name: string;
	resource_type: string;
	resource_id: any;
	blob_type: string;
	description: string;
	file_content: string;

	isInElaboration: boolean;
	file_size: number;
	mime_type: string;
	blob_name: string;
	created_at: string;



	static createFileContent(mFile: File): Observable<string> {
		return new Observable(
			observer => {
				const reader: FileReader = new FileReader();

                reader.onload = (event) => {
                    observer.next(event.target.result);
                    observer.complete();
                };

				reader.onerror = (error) => {
                    console.error('Error: ' + error);
					observer.next(null);
					observer.complete();
                };

                reader.readAsDataURL(mFile);
			});
	}

	static createMultiPartFile(mFile: File): Observable<any> {
		return new Observable(
			observer => {
				const file: FormData = new FormData();
				file.append('file', mFile);
				observer.next(file);
			});
	}

	/**
	 *  Restituisce il nome del file, compreso di estensione
	 * 
	 *  @returns {string}
	 */ 
	getFileName(): string {
		return this.file_name;
	}
}

export class BlobTypes {
	static ALLEGATO = 'att';
	static SURVEY_ATTACHED = 'survey_attached';
	static ATTESTATO_DI_CONSEGNA = 'adc';
	static ATTESTATO_DI_CONSEGNA_PROVVISORIO = 'adcp';
	static VERBALE_DI_RICONSEGNA = 'vdr';
	static VERBALED_DI_RICONSEGNA_PROVVISORIO = 'vdrp';
	static LETTERA_DI_CONSEGNA = 'ldc';
	static VERBALE_IR = 'vir';
	static CONTRATTO_CA = 'cca';
	static PATENTE = 'pt';
	static PATENTE_FRONTE = 'ptf';
	static PATENTE_RETRO = 'ptr';
	static CODICE_FISCALE = 'cf';
	static CODICE_FISCALE_FRONTE = 'cff';
	static CODICE_FISCALE_RETRO = 'cfr';
	static DELEGATE_PATENTE = 'ptd';
	static DELEGATE_PATENTE_FRONTE = 'ptfd';
	static DELEGATE_PATENTE_RETRO = 'ptrd';
	static DELEGATE_CODICE_FISCALE = 'cfd';
	static DELEGATE_CODICE_FISCALE_FRONTE = 'cffd';
	static DELEGATE_CODICE_FISCALE_RETRO = 'cfrd';
	static LETTER_REBILLABLE = 'lr';
	static BLOB_TYPE_FOR_ZIP = 'adz_img';
	static ACCEPTANCE_REPORT = 'act';
	static REDELIVERY_DOCUMENT = 'ric';
}

export class DocumentBlobTypesUtilities {

	static DELIVERY_DOCUMENT_OPTION_INDENTITA = 'identita';
	static DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE = 'identita-fronte';
	static DELIVERY_DOCUMENT_OPTION_INDENTITA_RETRO = 'identita-retro';
	static DELIVERY_DOCUMENT_OPTION_CF = 'codice-fiscale';
	static DELIVERY_DOCUMENT_OPTION_CF_FRONTE = 'codice-fiscale-fronte';
	static DELIVERY_DOCUMENT_OPTION_CF_RETRO = 'codice-fiscale-retro';
	static DOSSIER_ATTACHMENT_OPTION_ACCEPTANCE_REPORT = 'verbale-accettazione';
	static DOSSIER_ATTACHMENT_OPTION_REDELIVERY_DOCUMENT = 'documento-riconsegna';
	static BOOKING_CHECK_OUT_DOCUMENT = 'check-out';
	static BOOKING_CHECK_IN_DOCUMENT = 'check-in';


	static DELIVERY_DOCUMENT_OPTIONS = [DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA, DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE,
		DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_RETRO, DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF,
		DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE, DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_RETRO];

	static DOOSIER_ATTACHMENT_OPTIONS = [DocumentBlobTypesUtilities.DOSSIER_ATTACHMENT_OPTION_ACCEPTANCE_REPORT, DocumentBlobTypesUtilities.DOSSIER_ATTACHMENT_OPTION_REDELIVERY_DOCUMENT];

	static DRIVER_PERSONAL_DOCUMENT_BLOB_TYPES = [BlobTypes.PATENTE, BlobTypes.PATENTE_FRONTE, BlobTypes.PATENTE_RETRO,
		BlobTypes.CODICE_FISCALE, BlobTypes.CODICE_FISCALE_FRONTE, BlobTypes.CODICE_FISCALE_RETRO];

	static DELEGATE_PERSONAL_DOCUMENT_BLOB_TYPES = [BlobTypes.DELEGATE_PATENTE, BlobTypes.DELEGATE_PATENTE_FRONTE, BlobTypes.DELEGATE_PATENTE_RETRO,
		BlobTypes.DELEGATE_CODICE_FISCALE, BlobTypes.DELEGATE_CODICE_FISCALE_FRONTE, BlobTypes.DELEGATE_CODICE_FISCALE_RETRO];

	static DOOSIER_ATTACHMENT_BLOB_TYPES = [BlobTypes.ACCEPTANCE_REPORT, BlobTypes.REDELIVERY_DOCUMENT];

	static getBlobTypeForDocument(documentDescription: string, from: string[]): string {
		switch (documentDescription) {
			case DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTIONS[0]:
			case DocumentBlobTypesUtilities.DOOSIER_ATTACHMENT_OPTIONS[0]:
				return from[0];
			case DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTIONS[1]:
			case DocumentBlobTypesUtilities.DOOSIER_ATTACHMENT_OPTIONS[1]:
				return from[1];
			case DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTIONS[2]:
				return from[2];
			case DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTIONS[3]:
				return from[3];
			case DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTIONS[4]:
				return from[4];
			case DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTIONS[5]:
				return from[5];
		}
		return null;
	}

	static getDescriptionToDocumentFileByBlobType(blobType: string): string {
		switch (blobType) {
			case BlobTypes.PATENTE:
			case BlobTypes.DELEGATE_PATENTE:
				return DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA;
			case BlobTypes.PATENTE_FRONTE:
			case BlobTypes.DELEGATE_PATENTE_FRONTE:
				return DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_FRONTE;
			case BlobTypes.PATENTE_RETRO:
			case BlobTypes.DELEGATE_PATENTE_RETRO:
				return DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_INDENTITA_RETRO;

			case BlobTypes.CODICE_FISCALE:
			case BlobTypes.DELEGATE_CODICE_FISCALE:
				return DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF;
			case BlobTypes.CODICE_FISCALE_FRONTE:
			case BlobTypes.DELEGATE_CODICE_FISCALE_FRONTE:
				return DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_FRONTE;
			case BlobTypes.CODICE_FISCALE_RETRO:
			case BlobTypes.DELEGATE_CODICE_FISCALE_RETRO:
				return DocumentBlobTypesUtilities.DELIVERY_DOCUMENT_OPTION_CF_RETRO;
		}
	}

}
